

import { toggleModal, ADD_SHIFT_TO_LIST, UPDATE_SHIFT_IN_LIST, DELETE_SHIFT_FROM_LIST, ADD_SHIFTS_TO_LIST } from "./mutation-types";

export default {

        [toggleModal]: (state, value) =>{
            state.isShowAddOrUpdateModal = value;
        },

        [ADD_SHIFTS_TO_LIST]: (state, shiftsList) =>{
            state.shiftsList = shiftsList ;
        },
        
        [ADD_SHIFT_TO_LIST]: (state, shift) =>{
            state.shiftsList.push(shift);
        },

        [UPDATE_SHIFT_IN_LIST]: (state, updatedShift) =>{
            const index = state.shiftsList.findIndex(shift => shift.id === updatedShift.id);
            state.shiftsList[index] = updatedShift
        },

        [DELETE_SHIFT_FROM_LIST]: (state, shiftIDs) => {
            state.shiftsList.forEach((element, index) => { 
                shiftIDs.forEach(id=>{
                     if( id == element.id || id === element.id){
                        state.shiftsList.splice(index, 1);
                     }
                        
                });
            });

          },
          
}
